import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    Email: '',
    userID: null,
    loginToken: '',
    loginRefreshToken: '',
    isLoggedIn: false,
    Firstname: '',
    Lastname: '',
    Nickname: '',
    profileImageUrl: '',
    previous_url: null,
    last_student_subscription_rel_id: null,
    InstituteId: null,
    InstituteName: '',
    Institutelogoimageurl: null,
    LanguageId: null,
    LanguageName: null,
    Student_sub_PlanName: null,
    Student_sub_NumberOfMocktests: null,
    Student_sub_ShowAnalytics: null,
    Student_sub_StartDate: null,
    Student_sub_EndDate: null,
    Institute_sub_PlanName: null,
    Institute_sub_NumberOfMocktests: null,
    Institute_sub_NoOfStudents: null,
    Institute_sub_ShowAnalytics: null,
    Institute_sub_StartDate: null,
    Institute_sub_EndDate: null,
    IabhyasSearch: 0
}

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setloginEmailID: (state, action) => {
            state.Email = action.payload;
        },
        setUserID: (state, action) => {
            state.userID = action.payload;
        },
        setLoginToken: (state, action) => {
            state.loginToken = action.payload;
        },
        setLoginRefreshToken: (state, action) => {
            state.loginRefreshToken = action.payload;
        },
        setIsloggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        setUserFirtsName: (state, action) => {
            state.Firstname = action.payload;
        },
        setUserLastName: (state, action) => {
            state.Lastname = action.payload;
        },
        setUserNickname: (state, action) => {
            state.Nickname = action.payload;
        },
        setProfileImageUrl: (state, action) => {
            state.profileImageUrl = action.payload;
        },
        setPreviousUrl: (state, action) => {
            state.previous_url = action.payload;
        },
        setInstituteLogoImageUrl: (state, action) => {
            state.Institutelogoimageurl = action.payload;
        },
        setLanguageId: (state, action) => {
            state.LanguageId = action.payload;
        },
        setLanguageName: (state, action) => {
            state.LanguageName = action.payload;
        },
        setSubscriptionData: (state, action) => {
            const data = action.payload;
            state.last_student_subscription_rel_id = data.last_student_subscription_rel_id;
            state.InstituteId = data.InstituteId;
            state.InstituteName = data.Institute_Name;
            state.Institutelogoimageurl = data.Institutelogoimageurl;
            state.LanguageId = data.LanguageId;
            state.LanguageName = data.LanguageName;
            state.Student_sub_PlanName = data.Student_sub_PlanName;
            state.Student_sub_NumberOfMocktests = data.Student_sub_NumberOfMocktests;
            state.Student_sub_ShowAnalytics = data.Student_sub_ShowAnalytics;
            state.Student_sub_StartDate = data.Student_sub_StartDate;
            state.Student_sub_EndDate = data.Student_sub_EndDate;
            state.Institute_sub_PlanName = data.Institute_sub_PlanName;
            state.Institute_sub_NumberOfMocktests = data.Institute_sub_NumberOfMocktests;
            state.Institute_sub_NoOfStudents = data.Institute_sub_NoOfStudents;
            state.Institute_sub_ShowAnalytics = data.Institute_sub_ShowAnalytics;
            state.Institute_sub_StartDate = data.Institute_sub_StartDate;
            state.Institute_sub_EndDate = data.Institute_sub_EndDate;
            state.IabhyasSearch = data.IabhyasSearch;
        },
        clearUserData: (state) => {
            return initialState;
        },
    }
});

export default loginSlice.reducer;
export const { setloginEmailID, setUserID, setLoginToken, setLoginRefreshToken, setIsloggedIn, setUserFirtsName, setUserLastName, setUserNickname, setProfileImageUrl, setPreviousUrl, setInstituteLogoImageUrl, setLanguageId, setLanguageName, setSubscriptionData, clearUserData } = loginSlice.actions;